import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { AlertType } from 'mbs-ui-kit/alert/alert.model';
import { ModalComponent } from 'mbs-ui-kit/modal/modal.component';
import { MbsPopupType } from 'mbs-ui-kit/utils/enums/mbs-popup-enum';
import { HelpLinkDirective } from 'mbs-ui-shared@help/helpLink.directive';
import { AgentType } from 'mbs-ui-shared@models/Computer';

@UntilDestroy()
@Component({
  selector: 'mbs-bulk-agent-install-confirmation-modal-component',
  templateUrl: './computers-bulk-install-agent-confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    HelpLinkDirective,
    NgbTooltipModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    ModalFooterDirective
  ],
  standalone: true
})
export class ComputersBulkInstallAgentConfirmationModalComponent {
  private i18nPipe = inject(I18NextPipe);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
  public readonly mbsPopupType = MbsPopupType;
  public readonly agentType = AgentType;
  public readonly alertType = AlertType;
  public agent: AgentType;

  public get agentName(): string {
    return this.i18nPipe.transform(`shared:products.${this.agent}`);
  }

  public get confirmationQuestion(): string {
    return this.i18nPipe.transform('shared:computers.modals.bulkInstallAgentQuestion', { param: this.agentName });
  }
}
